<template>
  <div class="h-full">
    <el-dialog
      append-to-body
      :close-on-click-modal="false"
      title="选择人员"
      width="450px"
      top="30vh"
      :visible.sync="visible"
      :before-close="closeDialog"
    >
      <div class="w-full h-full" v-loading="tableLoading">
        <el-form :model="selectForm" label-width="120px" size="normal" ref="form" class="py-45px">
          <el-form-item label="部门" v-if="isMultiple">
            <el-select
              v-model="deptValue"
              filterable
              clearable
              placeholder="请选择"
              size="small"
              class="w-full"
            >
              <el-option
                v-for="item in deptList"
                :key="item.label"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="isMultiple"
            :label="formLabel"
            prop="multiplePeopleSelect"
            :rules="[
              {
                required: true,
                message: `请选择${formLabel}`,
                trigger: ['blur', 'change'],
              },
            ]"
          >
            <el-select
              v-model="selectForm.multiplePeopleSelect"
              class="w-full"
              filterable
              multiple
              placeholder="请选择"
            >
              <el-option
                v-for="item in tableData"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-else
            :label="formLabel"
            prop="singlePeopleSelect"
            :rules="[
              {
                required: true,
                message: `请选择${formLabel}`,
                trigger: ['blur', 'change'],
              },
            ]"
          >
            <el-select
              v-model="selectForm.singlePeopleSelect"
              class="w-full"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in tableData"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="isReportLeader"
            label="上报原因"
            prop="reportReason"
            :rules="[
              {
                required: true,
                message: `请填写上报原因`,
                trigger: ['blur', 'change'],
              },
            ]"
          >
            <el-input
              v-model="selectForm.reportReason"
              placeholder="请输入"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 6 }"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="flex flex-wrap justify-center items-center mt-20px">
          <el-button type="primary" size="small" @click="save"> 确定 </el-button>
          <el-button type="primary" size="small" @click="closeDialog"> 关闭 </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/babel">
import DiyService from '../../services/DiyService'

export default {
  name: 'person-select',
  components: {},
  props: {
    formLabel: {
      type: String,
      default: '',
    },
    isReportLeader: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    workFlowTaskId: {
      type: String,
      default: '',
    },
    nodeName: {
      type: String,
      default: '',
    },
    dataId: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    }, // 弹窗显隐
    // 是否禁用选择按钮
    disabled: {
      type: Boolean,
      default: false,
    },
    // 是否多选
    isMultiple: {
      type: Boolean,
      default: false,
    },
    value: {
      default: '',
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      workFlowDesignId: '',
      workFlowNodeId: '',
      searchOrganizationId: '',
      tableLoading: false,
      tableData: [],
      initUserList: [], // 初始化用户列表数据
      deptList: [], // 部门列表数据
      deptValue: '', // 部门
      saveLoading: false,
      selectForm: {
        multiplePeopleSelect: [],
        singlePeopleSelect: '',
        reportReason: '',
      },
    }
  },
  computed: {},
  watch: {
    visible(val) {
      if (val) {
        this.initDialog()
      }
    },
    deptValue(newValue) {
      this.selectForm.multiplePeopleSelect = []
      if (!newValue) {
        this.tableData = [...this.initUserList]
        return
      }
      this.tableData = this.initUserList.filter((item) => {
        return item.DeptName === newValue
      })
    },
  },
  methods: {
    // 获取待办
    async getByFlowTaskId() {
      const [err, res] = await DiyService.getTableData({
        TableName: 'WF_Work',
        _SearchEqual: { FlowId: this.workFlowTaskId },
        _Where: [{ Name: 'WorkState', Value: 'Todo', Type: '=' }],
      })
      if (!err && res.Code === 1 && res.Data?.length) {
        this.workFlowNodeId = res.Data[0].NodeId
      }
    },
    // 获取下一级节点用户
    async getNextNodeUsers() {
      const [err, res] = await DiyService.getNextNodeConfirmUsers({
        NodeId: this.workFlowNodeId,
        ApprovalType: 'Agree',
        '_Where[0]': { Name: 'LineName', Value: '上级领导审批', Type: '=' },
      })
      if (!err && res.Code === 1 && res.Data && res.Data.SelectUsers) {
        this.tableData = res.Data.SelectUsers
      }
    },
    // 初始化弹窗
    async initDialog() {
      this.tableLoading = true
      if (this.workFlowTaskId) {
        await this.getByFlowTaskId()
        await this.getNextNodeUsers()
      } else {
        await this.getDataDetail()
        await this.getWorkFlowNodes()
        await this.getUserList()
      }
      this.tableLoading = false
    },
    // 获取流程节点
    async getWorkFlowNodes() {
      const [err, res] = await DiyService.getTableData({
        TableName: 'WF_Node',
        _SearchEqual: { FlowDesignId: this.workFlowDesignId },
      })
      if (!err && res && res.Code === 1 && res.Data && res.Data.length) {
        const currentNode = _.find(res.Data, ['NodeName', this.nodeName])
        if (currentNode) {
          this.workFlowNodeId = currentNode.Id
        }
      }
    },
    // 获取流程
    async getWorkFlowDesign(name) {
      const [err, res] = await DiyService.getTableData({
        TableName: 'WF_FlowDesign',
        _PageSize: 15,
        _PageIndex: 1,
        _Where: [{ Name: 'FlowName', Value: name, Type: 'Like' }],
      })
      if (!err && res && res.Code === 1 && res.Data && res.Data.length) {
        const currentFlowDesign = _.find(res.Data, ['FlowName', '隐患治理审批主流程'])
        if (currentFlowDesign) {
          this.workFlowDesignId = currentFlowDesign.Id
        }
      }
    },
    // 获取数据详情
    async getDataDetail() {
      if (this.type === 'hiddenList') {
        await this.getWorkFlowDesign('隐患治理审批主流程')
      }
    },
    // 关闭弹窗
    closeDialog() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    // 保存
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit(
            'selected',
            this.isMultiple
              ? this.selectForm.multiplePeopleSelect
              : this.selectForm.singlePeopleSelect,
            this.selectForm.reportReason
          )
          this.$emit('update:visible', false)
        }
      })
    },
    // 获取用户列表
    async getUserList() {
      const [err, res] = await DiyService.getNodeConfirmUsers({
        NodeId: this.workFlowNodeId,
        ApprovalType: 'Agree',
      })
      if (!err && res.Code === 1 && res.Data && res.Data.SelectUsers) {
        this.tableData = res.Data.SelectUsers
        this.initUserList = [...res.Data.SelectUsers]
        const deptList = res.Data.SelectUsers.map((item) => {
          return item.DeptName
        })
        const filterDeptList = deptList.filter((item) => {
          return item
        })
        this.deptList = [...new Set(filterDeptList)].map((item) => {
          return {
            label: item,
            value: item,
          }
        })
      }
    },
  },
  created() {
    this.initDialog()
  },
}
</script>

<style scoped lang="scss">
.tree {
  height: calc(100% - 74px);
  ::v-deep .el-tree-node__content {
    height: 35px;
    .node-item {
      width: calc(100% - 24px);
      .custom-tree-node {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
  }
}
::v-deep .el-select-dropdown__item {
  background-color: #ffffff !important;
  overflow: hidden;
  flex-wrap: nowrap;
}
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-input__validateIcon {
  display: none;
}
.vertial-border {
  background-color: #0086f7;
}
</style>
